document.addEventListener("DOMContentLoaded", () => {
  // スマホ版のボタンにも同じ機能を付与
  const settingsButton = document.querySelector(
    ".cookie-settings-mobile .ot-sdk-show-settings"
  );
  if (settingsButton) {
    settingsButton.addEventListener("click", () => {
      // 元のボタンと同じ処理を実行
      document.getElementById("ot-sdk-btn").click();
    });
  }

  function alertMessage(itemsError = false) {
    if (itemsError) {
      const { errorItemSkus, cartItems } = itemsError;
      const div = document.createElement("div");
      div.classList.add("alert_error");
      if (errorItemSkus.length > 0) {
        let html = "<ul>";
        cartItems
          .filter((item) => errorItemSkus.find((sku) => sku === item.sku))
          .forEach((item) => {
            const duplicateTitle = cartItems.filter(
              (i) => i.title === item.title
            );
            html += `<li>${item.title}${
              duplicateTitle.length > 1 ? ` (${item.sku})` : ""
            } ${
              window?.cartStrings?.item_error_inventory ||
              "is out of stock. To proceed to checkout, please remove it from your cart."
            }</li>`;
          });
        html += "</ul>";
        div.innerHTML = `<p>${
          window?.cartStrings?.error_inventory ||
          "* Error: Please check the message below."
        }</p>${html}`;
      } else {
        div.innerHTML = `${
          window?.cartStrings?.error_unknown ||
          "Some errors. Check console error message"
        }`;
        console.log("response: allocated is false but no errorItemSkus");
      }
      const par = document.querySelector(".cart__warnings");
      par?.appendChild(div);
    } else {
      document.querySelector(".alert_error")?.remove();
    }
  }
  async function checkInventory() {
    const cartText = await fetch("/?section_id=cart-json").then((res) =>
      res.text()
    );
    const cartHtml = new DOMParser()
      .parseFromString(cartText, "text/html")
      .querySelector(".shopify-section").innerHTML;
    const cartJson = JSON.parse(cartHtml);
    const data = cartJson.items.map((item) => ({
      sku: item.sku,
      quantity: item.quantity,
      saleMethod: item.saleMethod,
    }));
    const haveItemSku = data.some((item) => item.sku);
    if (!haveItemSku) {
      return {
        allocated: true,
      };
    }
    const inventory = await fetch("/a/proxy/check-inventory", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((res) => res)
      .catch((err) => {
        console.error(err);
        return {
          allocated: true,
          errorItemSkus: [],
        };
      });
    inventory.cartItems = cartJson.items;
    return inventory;
  }
  document.querySelectorAll('form[action="/cart"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      e.submitter.classList.add("loading");
      if (e.submitter.querySelector(".loading__spinner")) {
        e.submitter
          .querySelector(".loading__spinner")
          .classList.remove("hidden");
      }
      e.submitter.disabled = true;

      alertMessage();
      const haveError = await checkInventory();
      if (haveError.allocated) {
        window.location.href = "/checkout";
      } else {
        alertMessage(haveError);
      }
      e.submitter.classList.remove("loading");
      if (e.submitter.querySelector(".loading__spinner")) {
        e.submitter.querySelector(".loading__spinner").classList.add("hidden");
      }
      e.submitter.disabled = false;
    });
  });

  document.querySelectorAll('link[href*="/checkout"]').forEach((link) => {
    link.addEventListener("click", async (e) => {
      e.preventDefault();
      link.classList.add("loading");
      if (link.querySelector(".loading__spinner")) {
        link.querySelector(".loading__spinner")?.classList.remove("hidden");
      }
      alertMessage();
      const haveError = await checkInventory();
      if (haveError.allocated) {
        link.click();
      } else {
        alertMessage(haveError);
      }
      link.classList.remove("loading");
      if (link.querySelector(".loading__spinner")) {
        link.querySelector(".loading__spinner")?.classList.add("hidden");
      }
    });
  });

  document.querySelectorAll(".js-reorder").forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      e.preventDefault();
      btn.classList.add("loading");
      const { variants } = btn.dataset;
      let { href } = btn.dataset;
      let availableId = [];
      try {
        const variantsArray = JSON.parse(variants);
        const variantSku = variantsArray.filter(
          (variant) => variant.sku !== ""
        );
        const inventory = await fetch("/a/proxy/check-inventory", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(variantSku),
        })
          .then((response) => response.json())
          .then((res) => res)
          .catch((err) => {
            console.error(err);
          });
        availableId = variantsArray
          .filter((variant) => !inventory.errorItemSkus.includes(variant.sku))
          .map((variant) => variant.id);
        href = `/cart/${availableId
          .map((id) => `${id}:1`)
          .join(",")}?storefront=true`;
      } catch (error) {
        console.log(error);
      }
      if (availableId.length > 0) {
        window.location.href = href;
      } else {
        alert(
          "Sorry, there are no products in your order available for you to reorder."
        );
      }
      btn.classList.remove("loading");
    });
  });
  document
    .querySelectorAll('input:not([type="hidden"])[id*="phone"]')
    .forEach((input) => {
      const changePhoneValue = (val) => {
        const form = input.closest("form");
        const inputReal =
          form.querySelector('input[type="hidden"][name*="phone"]') ||
          form.querySelector('input[type="hidden"][id*="phone"]');
        const nameReal = inputReal?.name || input?.name || "";
        const elmAlert = document.querySelector(`[data-error="${nameReal}"]`);
        if (elmAlert) {
          elmAlert.innerHTML = "";
        }
        if (input.formatted.isValidNumber()) {
          if (inputReal) {
            inputReal.value = val;
          }
        } else if (input.value.trim().length > 0) {
          const msg =
            window.intlTelInputString[input.formatted.getValidationError()] ||
            "Invalid number";
          if (elmAlert) {
            elmAlert.innerHTML = `<li>${msg}</li>`;
          }
        }
      };
      const i18nDefault = {
        // Aria label for the selected country element
        selectedCountryAriaLabel:
          window.intlTelString.selectedCountryAriaLabel || "Selected country",
        // Screen reader text for when no country is selected
        noCountrySelected:
          window.intlTelString.noCountrySelected || "No country selected",
        // Aria label for the country list element
        countryListAriaLabel:
          window.intlTelString.countryListAriaLabel || "List of countries",
        // Placeholder for the search input in the dropdown
        searchPlaceholder: window.intlTelString.searchPlaceholder || "Search",
        // Screen reader text for when the search produces no results
        zeroSearchResults:
          window.intlTelString.zeroSearchResults || "No results found",
        // Screen reader text for when the search produces 1 result
        oneSearchResult:
          window.intlTelString.oneSearchResult || "1 result found",
        // Screen reader text for when the search produces multiple results
        multipleSearchResults:
          window.intlTelString.multipleSearchResults ||
          "${count} results found",
      };
      const options = {
        utilsScript:
          "https://cdn.jsdelivr.net/npm/intl-tel-input@24.5.0/build/js/utils.js",
        initialCountry: "us",
        i18n: i18nDefault,
        // autoPlaceholder: 'aggressive',
        strictMode: true,
        separateDialCode: true,
      };
      input.formatted = window.intlTelInput(input, options);
      input.addEventListener("focusout", () =>
        changePhoneValue(input.formatted.getNumber())
      );
      input.addEventListener("countrychange", () =>
        changePhoneValue(input.formatted.getNumber())
      );
    });
});
